import { Directive, Host } from '@angular/core'
import { I18nService } from 'app/_services/i18n.service'
import { BsDaterangepickerDirective, BsLocaleService } from 'ngx-bootstrap/datepicker'

/**
 * Directive that works in conjunction with the ngx-bootstrap daterangepicker directive and adds i18n locale change support.
 */
@Directive({
    selector: `[appI18nBsDaterangepickerRender]`,
})
export class AppBsDaterangepickerInputDirective {
    constructor(
        @Host() private picker: BsDaterangepickerDirective,
        private i18nService: I18nService,
        private bsLocaleService: BsLocaleService
    ) {
        this.i18nService.messages.subscribe(() => {
            this.bsLocaleService.use(this.i18nService.languageId)
            this.picker.ngOnChanges({})
        })
    }
}
